import every from 'lodash/every';
import has from 'lodash/has';
import isArray from 'lodash/isArray';

export function isChoices(schemata) {
  if (!isArray(schemata)) {
    return false;
  }
  return every(schemata, (schema) => {
    return has(schema, 'const');
  });
}

export function toChoice(schema) {
  return {
    value: schema.const,
    label: schema.title || schema.const,
    ...(schema['x-group'] !== undefined ? { group: schema['x-group'] } : {}),
  };
}

export function buildOptions(question, valueSet, t) {
  if (valueSet) return question.getChoices(valueSet);
  const { choices } = question;
  if (!choices || !choices.some((c) => c.group !== undefined)) {
    return question.getChoices();
  }
  const groupMap = new Map();
  choices.forEach(({ value, label, group }) => {
    if (!groupMap.has(group)) {
      groupMap.set(group, { label: t ? t(group) : group, options: [] });
    }
    groupMap.get(group).options.push({ value, label: label || value });
  });
  return Array.from(groupMap.values());
}
